export const errorTemplates = {
  genericMessage: (action: string) => `Ocurrió un error al ${action}. Reintenta más tarde.`,
  genericTitle: 'Ocurrió un error inesperado',
};
